import { createAppProvider } from 'marketing-platform-lib/utils/createAppProvider';
import { getWindowCachedFollower } from './collaborationSidebarState';
import { getWindowCachedUnreadCommentCountFollower } from './unreadCommentCountState';
import { createStoreHooks } from 'collaboration-sidebar-common/store/store';
export const {
  AppProvider: CollaborationSidebarProvider,
  useAppValue: useCollaborationSidebarValue,
  useOptionalAppValue: useOptionalCollaborationSidebarValue
} = createAppProvider();
function useCollaborationSidebarStore() {
  "use memo";

  var _useOptionalCollabora;
  return (_useOptionalCollabora = useOptionalCollaborationSidebarValue("collaborationSidebarState")) !== null && _useOptionalCollabora !== void 0 ? _useOptionalCollabora : getWindowCachedFollower();
}
export const {
  useStateValue,
  useSelectorValue: useCollaborationSidebarStateValue,
  useShallowSelectorValue: useCollaborationSidebarStateShallowValue,
  useActions: useCollaborationSidebarActions
} = createStoreHooks(useCollaborationSidebarStore);
function useUnreadCommentCountStore() {
  "use memo";

  var _useOptionalCollabora2;
  return (_useOptionalCollabora2 = useOptionalCollaborationSidebarValue("unreadCommentCountState")) !== null && _useOptionalCollabora2 !== void 0 ? _useOptionalCollabora2 : getWindowCachedUnreadCommentCountFollower();
}
export const {
  useSelectorValue: useUnreadCommentCountStateValue,
  useActions: useUnreadCommentCountActions
} = createStoreHooks(useUnreadCommentCountStore);